<template>
  <div class="floor-viewer" ref="wrapper" :style="computedStyle">
    <div v-if="floor" class="floor-viewer__inner">
      <header>
        <h3 class="floor-viewer__heading">
          <span v-html="lang === 'sk' ? 'Vybrané: '+ title : 'Selected: '+ title "></span>
        </h3>
      </header>
      <main>
        <i-explorable
          class="floor-viewer__plan-wrapper"
          :max-zoom="floors[floor].maxZoom"
          :enable-mouse-wheel-zoom="false"
          :enable-strict-boundaries="true"
          :zoom-animation-duration="75"
          @grabstart="ongrabstart"
          @grabend="ongrabend"
          @zoom="onzoom"
        >
          <div class="floor-viewer__plan-inner">
            <!-- <h3 class="floor-viewer__heading">
              <span>{{ title }}</span>
            </h3>-->
            <img :src="imgsrc" class="floor-viewer__plan" ref="plan" />
            <svg class="floor-viewer__plan-overlay" :viewBox="floors[floor].viewBox" ref="overlay">
              <template v-for="(apartment, key) in floors[floor].apartments">
                <polygon
                  @click="apartmentClick(apartment)"
                  :key="'apartmnet-' + floor + '-' + key"
                  :points="apartment.points"
                />
              </template>
            </svg>
          </div>
        </i-explorable>
      </main>
      <!-- <footer>
        <mini-plan></mini-plan>
      </footer>-->
    </div>
  </div>
</template>

<script>
import { mapGetters, HTMLBox } from 'utils/misc';
import { wait, AnimationFrame } from 'utils/timing';

import { IMG_URL } from 'src/constants';
import floors from './floors';

import IExplorable from '../IExplorable.vue';
import MiniPlan from '../MiniPlan.vue';

const TITLES = {
  'veza-2NP': '2NP, Veža',
  'veza-3NP': '3NP, Veža',
  'veza-4NP': '4NP, Veža',
  'veza-5NP': '5NP, Veža',
  'veza-6NP': '6NP, Veža',
  '3NP': '3NP, Hlavná budova',
  '4NP': '4NP, Hlavná budova',
  '5NP': '5NP, Hlavná budova',
  '6NP': '6NP, Hlavná budova'
};

const EN_TITLES = {
  'veza-2NP': '2nd floor, Tower',
  'veza-3NP': '3rd floor, Tower',
  'veza-4NP': '4th floor, Tower',
  'veza-5NP': '5th floor, Tower',
  'veza-6NP': '6th floor, Tower',
  '3NP': '3rd floor, Main building',
  '4NP': '4th floor, Main building',
  '5NP': '5th floor, Main building',
  '6NP': '6th floor, Main building'
};

export default {
  name: 'floor-viewer',
  components: {
    IExplorable,
    MiniPlan,
  },
  computed: {
    ...mapGetters({
      slide: ['getSlide', 'setSlide'],
      floor: ['getFloor', 'setFloor'],
      lang: ['getLang']
    }),
    title() {
      return this.lang === 'en' ? EN_TITLES[this.floor] : TITLES[this.floor] ;
    },
    imgsrc() {
      return require('../../assets/img/floors/' + this.floor + '.png');
    },
    computedStyle() {
      return { height: this.floor == null ? '1px' : null };
    },
  },
  data() {
    return {
      floors,
      window,
      grab: false,
      animationFrame: null,
      zoom: 1,
    };
  },
  methods: {
    apartmentClick(apartment) {
      if (!this.grab && this.lang === 'sk') {
        window.open(apartment.pdf, '_blank');
      }
      else{
        window.open(apartment.en, '_blank');
      }
    },
    ongrabstart() {
      wait(0).then(() => (this.grab = true));
    },
    ongrabend({ history }) {
      history.length == 0 ? (this.grab = false) : wait(0).then(() => (this.grab = false));
    },
    onzoom({ zoom }) {
      this.zoom = zoom;
    },
  },
  created() {
    this.animationFrame = new AnimationFrame(() => {
      if (this.$refs.plan && this.$refs.overlay) {
        const plan = new HTMLBox(this.$refs.plan);
        const overlay = new HTMLBox(this.$refs.overlay);

        overlay.width = plan.width / this.zoom;
        overlay.height = plan.height / this.zoom;
      }
    }).start();
  },
  beforeDestroy() {
    if (this.animationFrame) {
      this.animationFrame.stop();
    }
  },
};
</script>
